import { StatusOrder } from './../../../models/order/enums/status-order.enum';
import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { AnyARecord } from 'dns';
import { OrderStatusEnum } from 'src/app/models/order/enums/order-status.enum';

import { OrderDetails } from 'src/app/models/order/order-details.model';

@Component({
    selector: 'order-details-items-table',
    templateUrl: './items-table.component.html',
    styleUrls: ['./items-table.component.scss'],
    standalone: false
})
export class ItemsTableComponent implements OnInit {

  // @Input() order: OrderDetails;
  @Input() order: any;
  isRecurring: boolean = false;
  isScheduled: boolean = false;
  statusOrder = new StatusOrder;
  constructor(private elRef: ElementRef) { }

  ngOnInit(): void {
    this.isRecurring =  this.order.Status === 'RECURRING';
    this.isScheduled =  this.order.Status === 'SCHEDULED';

    this.order.items.forEach(item => {
      var allStatus = this.statusOrder.getCurrentStatusOrder();
      item.infoitems_Status=allStatus[item.infoitems_Status.toUpperCase()]?allStatus[item.infoitems_Status.toUpperCase()]:item.infoitems_Status;

    });
  }

}
